var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBin = function SvgBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.767 1.334h-4L11.353.61a.585.585 0 0 0-.511-.276H5.834a.585.585 0 0 0-.51.276l-.415.724h-4c-.315 0-.571.224-.571.5v1c0 .276.256.5.571.5h14.857c.316 0 .572-.224.572-.5v-1c0-.276-.257-.5-.572-.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.249 3.334 1 11.5c0 .828.783 1.5 1.75 1.5h8.5c.966 0 1.75-.672 1.75-1.5l1-11.5h-14Zm4.083 10c0 .277-.26.5-.583.5-.324 0-.584-.222-.584-.5v-7c0-.278.26-.5.584-.5.323 0 .583.222.583.5v7Zm3.5 0c0 .277-.26.5-.583.5-.324 0-.584-.222-.584-.5v-7c0-.278.26-.5.584-.5.323 0 .583.222.583.5v7Zm3.5 0c0 .277-.26.5-.584.5-.323 0-.583-.223-.583-.5v-7c0-.278.26-.5.584-.5.323 0 .583.222.583.5v7Z"
  })));
};

export default SvgBin;